import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../../config/apiConfig';
import EmigrantsHero from '../../components/Emigrants/EmigrantsHero';
import TrustedByEmbassies from '../../components/ForeignEmployers/TrustedByEmbassies';
import WhyCandidatesTrustUs from '../../components/Emigrants/WhyCandidatesTrustUs';
import ExploreCandidateServices from '../../components/Emigrants/ExploreCandidateServices';
import OurCommitmentToYou from '../../components/Emigrants/OurCommitmentToYou';
import GlobalPartnerSection from '../../components/home/GlobalPartnerSection';
import EmigrantJobsAbroad from '../../components/Emigrants/EmigrantJobsAbroad';
import OurAdditionalServices from '../../components/Emigrants/OurAdditionalServices';
import CommitmentExcellence from '../../components/ForeignEmployers/CommitmentExcellence';
import IndustriesWeCater from '../../components/Recruitment/IndustriesWeCater';
import EmigrantCTA from '../../components/Emigrants/EmigrantCTA';
import ContactSection from '../../components/ContactSection';
import TestimonialSection from '../../components/common/TestimonialSection';

const Emigrants = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_CONFIG.BASE_URL}/emigrant-fe-page`, {
          headers: API_CONFIG.HEADERS
        });
        if (response.data.success || response.data.status === 'success' || response.data.data) {
          setData(response.data.data || response.data);
        }
      } catch (error) {
        console.error("Error fetching Emigrant FE page data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center font-poppins text-[#0d213b]">Loading...</div>;
  }

  return (
    <main className="min-h-screen bg-white">
      <EmigrantsHero data={data?.hero} />
      <TrustedByEmbassies data={data?.trusted_by_section} />
      <WhyCandidatesTrustUs data={data?.why_candidates_section} />
      <ExploreCandidateServices data={data?.candidate_services_section} />
      <OurCommitmentToYou data={data?.commitment_cards_section} />
      <GlobalPartnerSection data={data?.happy_section} />
      <EmigrantJobsAbroad data={data?.jobs_section} />
      <OurAdditionalServices data={data?.additional_services_section} />
      <CommitmentExcellence data={data?.excellence_section} imageLeft={true} />
      <EmigrantCTA data={data?.final_cta_section} />
      
      {data?.testimonials_section && (
        <>
          <div className="bg-primary-lightblue md:py-10 py-8 rounded-b-[85%]" />
          <TestimonialSection data={data.testimonials_section} />
        </>
      )}

      <ContactSection />
    </main>
  );
};

export default Emigrants;

